import { setCurrentPageNo } from "pages/AllArticles/articlesSlice";
import { useCallback, useEffect, useState } from "react";

import { useDispatch } from "react-redux";
// import { DeleteIcon, EditIcon, TableDatePicker } from "themes/Icon";
import AvatarComp from "themes/elements/Avatar";
import ButtonComp from "themes/elements/Button";
import EmptyState from "themes/elements/EmptyState";
import PaginationComp from "themes/elements/Pagination";
// import { isPermit } from "utils/permissionCheck";
import { DeleteIcon, EditIcon, TableDatePicker } from "themes/Icon";
import SearchComp from "themes/elements/Search";
import TagComp from "themes/elements/Tag";
import TooltipComp from "themes/elements/Tooltip";
import { isPermit } from "utils/permissionCheck";
import DatePickerComp from "../../DatePicker";

import "../table_comp.scss";
function AllArticlesTable({
  column,
  data,
  dataClick,
  approve = false,
  onDeleteAction,
  currentPageNo,
  totalPageNo,
  handleEdit,
  setSelectedData = () => {},
  isLoading,
  editAction = false,
  filterRegion,
  filterWard,
  filterCouncillor,
  filterTerm,
  filterDate,
  setFilterDate = () => {},
  setFilterReason = () => {},
  setFilterTerm = () => {},
  setFilterRegion = () => {},
  setFilterWard = () => {},
  setFilterCouncillor = () => {},
  setFilterReqCouncillor = () => {},
  setDetails = () => {},
}) {
  const [currentPageData, setCurrentPageData] = useState([]);
  const dispatch = useDispatch();

  useEffect(() => {
    setCurrentPageData(data);
    setSelectedData([]);
  }, [data]);

  const handlePageChange = (page) => {
    dispatch(setCurrentPageNo(page));
  };

  function debounce(func, delay) {
    let timerId;
    return function (...args) {
      if (timerId) {
        clearTimeout(timerId);
      }
      timerId = setTimeout(() => {
        func(...args);
      }, delay);
    };
  }

  const handleSearchChangeDebounced = useCallback(
    debounce((value, type) => {
      dispatch(setCurrentPageNo(1));
      if (type === "region") {
        setFilterRegion(value);
      } else if (type === "ward") {
        setFilterWard(value);
      } else if (type === "reason") {
        setFilterReason(value);
      } else if (type === "councilor") {
        setFilterCouncillor(value);
      } else if (type === "requester") {
        setFilterReqCouncillor(value);
      }
    }, 50),
    []
  ); // 300 ms debounce time

  // This function is what gets called by the event listener
  const handleSearchChange = (event, type) => {
    const value = event.target.value;
    handleSearchChangeDebounced(value, type);
  };

  const SkeletonRow = ({ columns }) => (
    <tr className="table-row">
      {columns.map((col, index) => (
        <td key={index} className="table-data" style={{ width: col.width }}>
          <div className="skeleton-box"></div>
        </td>
      ))}
    </tr>
  );

  const clearFilters = () => {
    dispatch(setCurrentPageNo(1));
    setCurrentPageData(data);
    setFilterRegion("");
    setDateChange(null);
    setFilterWard("");
    setFilterTerm();
    setFilterCouncillor("");
    setFilterReason();
    setFilterReqCouncillor();
    setFilterDate();
  };

  const onDataClick = (row) => {
    dataClick(row);
  };

  const [dateChange, setDateChange] = useState(null);
  const formatDate = (dateString) => {
    const [day, month, year] = dateString.split("-");
    return `${year}-${month}-${day}`;
  };

  const handleDateChange = (dateString) => {
    setDateChange(dateString);
    dispatch(setCurrentPageNo(1));
    if (dateString) {
      const formattedDate = formatDate(dateString);
      setFilterDate(formattedDate);
    } else {
      setFilterDate(null);
    }
  };

  return (
    <div className="table-wrapper">
      <table className="table-comp">
        <thead className="table-head">
          <tr className="table-row">
            {column.map((col, i) => (
              <th
                className="table-header"
                key={i}
                style={{ minWidth: col.width }}
              >
                <span className="flex align-center gap-3">{col.title}</span>
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="table-body">
          <tr className="table-row">
            {column.map((col, i) => (
              <td className="table-data" style={{ width: col.width }} key={i}>
                {col.filter === "searchTitle" ? (
                  <SearchComp
                    className="table-search"
                    height={33}
                    bgNone
                    placeholder="Search..."
                    value={filterRegion}
                    onChange={(e) => handleSearchChange(e, "region")}
                  />
                ) : col?.filter === "dateChange" ? (
                  <DatePickerComp
                    className="table-date-picker"
                    suffixIcon={<TableDatePicker />}
                    onChange={handleDateChange}
                    setValue={setDateChange}
                    value={dateChange}
                  />
                ) : col.filter === "searchCouncillor" ? (
                  <SearchComp
                    className="table-search"
                    height={33}
                    bgNone
                    placeholder="Search..."
                    value={filterCouncillor}
                    onChange={(e) => handleSearchChange(e, "councilor")}
                  />
                ) : col.filter === "searchNumber" ? (
                  <SearchComp
                    type="number"
                    className="table-search"
                    height={33}
                    bgNone
                    placeholder="Search..."
                    value={filterWard}
                    onChange={(e) => handleSearchChange(e, "ward")}
                  />
                ) : null}
              </td>
            ))}
          </tr>
          {(filterRegion ||
            filterDate ||
            filterWard ||
            filterCouncillor ||
            filterTerm) && (
            <div className="clr-btn-container">
              <ButtonComp height={16} variant="link" onClick={clearFilters}>
                Clear filters
              </ButtonComp>
            </div>
          )}
          {!isLoading ? (
            currentPageData?.length > 0 ? (
              currentPageData.map((row) => (
                <tr className="table-row" key={row?.id}>
                  {column.map((col, colIndex) => {
                    return (
                      <td
                        style={{ width: col.width }}
                        className="table-data"
                        key={colIndex}
                      >
                        {col.key === "created_user_name" &&
                        row[col.key] !== null ? (
                          <div className="flex align-center no_cursor">
                            {row?.councilor_image?.length > 0 &&
                            row[col.key] !== null ? (
                              <span className="councilor_image">
                                <AvatarComp
                                  size={32}
                                  blue
                                  src={row.councilor_image}
                                />
                              </span>
                            ) : (
                              <span className="councilor_image">
                                <AvatarComp size={32} blue>
                                  {row?.first_name?.replace(" ", "")[0]}
                                </AvatarComp>
                              </span>
                            )}

                            <span
                              className="table-title ml-3 no_cursor"
                              onClick={() => {
                                onDataClick(row);
                              }}
                            >
                              {row.first_name + " " + row.last_name}
                            </span>
                          </div>
                        ) : col.key === "title" ? (
                          <div
                            onClick={() => {
                              onDataClick(row);
                              setDetails(true);
                            }}
                            className="flex align-center"
                          >
                            {row?.images[0]?.project_image?.length > 0 &&
                            row[col.key] !== null ? (
                              <span className="councilor_image">
                                <AvatarComp
                                  shape="square"
                                  size={32}
                                  blue
                                  src={row?.images[0]?.project_image}
                                />
                              </span>
                            ) : (
                              <>
                                <span className="councilor_image">
                                  <AvatarComp size={32} shape="square" blue>
                                    {row.title?.replace(" ", "")[0]}
                                  </AvatarComp>
                                </span>
                              </>
                            )}
                            <TooltipComp title={row.title}>
                              <span className="limit-lines align-center ml-3 cursor-pointer">
                                {row.title}
                              </span>
                            </TooltipComp>
                          </div>
                        ) : col.key === "author" ? (
                          <div
                            className={`flex align-center no_cursor  ${
                              approve ? "" : ""
                            }`}
                          >
                            <div>
                              <div className=" ">
                                {row?.first_name ? (
                                  <AvatarComp
                                    size={32}
                                    blue
                                    src={row.created_user_image}
                                  />
                                ) : (
                                  <AvatarComp size={32} blue>
                                    {row.first_name?.replace(" ", "")[0]}
                                  </AvatarComp>
                                )}

                                <TooltipComp title={row.first_name}>
                                  <span
                                    className="table-title ml-3"
                                    onClick={() => {
                                      onDataClick(row);
                                    }}
                                  >
                                    {row?.first_name + " " + row?.last_name}
                                  </span>
                                </TooltipComp>
                              </div>
                              editAction
                            </div>
                          </div>
                        ) : col.key === "status" ? (
                          <div>
                            <TagComp
                              className={
                                row?.project_status_flg === 1
                                  ? "ant-tag-green"
                                  : "ant-tag-red"
                              }
                            >
                              {row?.project_status_flg === 1
                                ? "Published"
                                : "Rejected"}
                            </TagComp>
                          </div>
                        ) : (
                          // </TooltipComp>
                          <span className="flex align-center gap-2">
                            {row[col.key]}
                          </span>
                        )}

                        <div className="action-container">
                          {editAction && isPermit(8, "edit") && (
                            <ButtonComp
                              onClick={() => {
                                handleEdit(row);
                              }}
                              height={32}
                              rounded
                            >
                              <EditIcon />
                            </ButtonComp>
                          )}
                          {isPermit(8, "delete") && (
                            <ButtonComp
                              onClick={() => {
                                onDeleteAction(row);
                              }}
                              height={32}
                              rounded
                            >
                              <DeleteIcon />
                            </ButtonComp>
                          )}
                        </div>
                      </td>
                    );
                  })}
                </tr>
              ))
            ) : (
              <EmptyState />
            )
          ) : (
            Array(10)
              .fill(0)
              .map((_, index) => <SkeletonRow key={index} columns={column} />)
          )}
        </tbody>
      </table>

      <PaginationComp
        isLoading={isLoading}
        currentPageNo={currentPageNo}
        total={totalPageNo}
        onChange={handlePageChange}
      />
    </div>
  );
}

export default AllArticlesTable;
